import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .name
  .uuid
  .startDate
  .projectId
  .isLocked
  .deleted
  .isDispatched
  .isScheduling
  .isUnscheduling
  .isDeleting
  .solutionId
  .unpublishedChanges
  .isStarted
  .hexColor
  .driver(driver => driver.deleted.name.invite(i => i.email.inviteLink.inviteStatusId))
  .constraints(constraint => constraint
    .capacity
    .duration
    .startTime
    .endTime
    .startLocations(startLocation => startLocation.address.latitude.longitude.active.bestMatch.locationStatusId)
    .endLocations(endLocation => endLocation.address.latitude.longitude.active.bestMatch.locationStatusId))
  .activeRouteSolution(routeSolution => routeSolution
    .id
    .violations(violation => violation
      .type
      .value
      .name
      .routeSolutionId)
    .stopsCount
    .drivingTime
    .distance
    .polyline
    .load
    .distance
    .workingTime
    .finished)
  .toString();
